import React, { useState, useEffect } from 'react';
import FilterSidebar from '../../components/FilterSidebar/FilterSidebar';
import ProductCard from '../../components/ProductCard/ProductCard';
import './Collections.css';
import { useParams } from 'react-router-dom';
import CollectionsSkeleton from './CollectionsSkeleton';

const Collections = () => {
  const [showFilters, setShowFilters] = useState(true);
  const [wishlistItems, setWishlistItems] = useState([]);
  const { slug } = useParams();
  const [fetchedProducts, setFetchedProducts] = useState([]);
  const [collectionTitle, setCollectionTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({ colors: [], sizes: [], productTypes: [], pricings: [] });
  const [selectedFilters, setSelectedFilters] = useState({});
  
  const base_url = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const savedWishlist = localStorage.getItem('wishlist');
    if (savedWishlist) {
      try {
        const parsedWishlist = JSON.parse(savedWishlist);
        setWishlistItems(parsedWishlist);
      } catch (error) {
        console.error('Error parsing wishlist from localStorage:', error);
      }
    }
  }, []);


  const displayedProducts = fetchedProducts.map((p) => ({
    id: p.product_id,
    title: p.name,
    color: p.color,
    price: Number(p.base_price),
    originalPrice: Number(p.base_price),
    discount: p.discount || null,
    slug: p.slug,
    description: p.description,
    frontImage: p.front_image,   // use backend field names
    backImage: p.back_image,     // adjust if your API has these
    soldOut: p.sold_out || false,
    variants: p.variants || []
  }));

  useEffect(() => {
    setLoading(true);
    setError('');

    console.log("selectedFilters", selectedFilters);
    
    const queryParams = new URLSearchParams({
      page: 1,
      limit: 20,
      sort: selectedFilters.sort || 'newest',
      color: (selectedFilters.colors || []).join(','),
      size: (selectedFilters.sizes || []).join(','),
      category_id: (selectedFilters.productTypes || []).join(',')
    });


    console.log(`${base_url}/collections/${slug}?${queryParams}`)
    
    fetch(`${base_url}/collections/${slug}?${queryParams}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setCollectionTitle(data.collection.title);
          setFetchedProducts(data.products || []);
          console.log("fetchedProducts", data.products || [])
          setFilters(data.filters || {}); // ✅ keep filters updated
        } else {
          setError(data.message || 'Collection not found');
          setFetchedProducts([]);
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch collection');
        setLoading(false);
      });
  }, [slug, selectedFilters]);
  
  
  return (
    <div className="collections-page">
      <div className="collections-header">
        <h1>{collectionTitle || 'MENS NEW RELEASES'}</h1>
        <button
          className="hide-filter-btn"
          onClick={() => setShowFilters(!showFilters)}
        >
          <span>Hide Filter</span>
          <div className="filter-icon">
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </button>
      </div>

      <div className="collections-content">
        {showFilters && <FilterSidebar 
          filters={filters} 
          selectedFilters={selectedFilters} 
          onFilterChange={(updatedFilters) => setSelectedFilters(updatedFilters)} 
        />}

        <main className="product-grid">
          {loading ? (
            <CollectionsSkeleton showFilters={showFilters} />
          ) : error ? (
            <p>{error}</p>
          ) : (
            displayedProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                isInWishlist={wishlistItems.some(item => item.id === product.id)}
                onWishlistToggle={() => {
                  const isInWishlist = wishlistItems.some(item => item.id === product.id);
                  if (isInWishlist) {
                    const updatedWishlist = wishlistItems.filter(item => item.id !== product.id);
                    setWishlistItems(updatedWishlist);
                    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
                  } else {
                    const newWishlistItem = {
                      ...product,
                      addedAt: new Date().toISOString()
};
                    const updatedWishlist = [...wishlistItems, newWishlistItem];
                    setWishlistItems(updatedWishlist);
                    localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
                  }
                }}
              />
            ))
          )}
        </main>
      </div>
    </div>
  );
};

export default Collections; 